import styled from '@emotion/styled';
import {
	Css,
	ITheme,
	Responsive,
	Shimmer,
	ShimmerPlaceholderText,
} from '../../../ui';
import {
	InfoCard,
	InfoCardDivider,
	InfoCardIcons,
	InfoCardTitleSection,
	InfoCardTop,
} from '../../../components/common/cards/InfoCard/InfoCard.styles';

export default function SecurityCardsShimmer() {
	return (
		<StyledShimmer>
			{[...Array(6)].map((_, index) => (
				<StyledInfoCard
					key={index} /* eslint-disable-line react/no-array-index-key */
				>
					<InfoCardTop>
						<TopSection>
							<InfoCardTitleSection>
								<StyledShimmerTitleIcon />
								<StyledShimmerTitle />
							</InfoCardTitleSection>
							<div>
								<StyledShimmerDescription />
							</div>
						</TopSection>
						<TopSection>
							<InfoCardIcons>
								<StyledShimmerIcons />
							</InfoCardIcons>

							<StyledShimmerRemark />
						</TopSection>
					</InfoCardTop>

					<InfoCardDivider />

					<hr />
					<StyledShimmerBottomLeft />
				</StyledInfoCard>
			))}
		</StyledShimmer>
	);
}

const StyledShimmer = styled(Shimmer)<{}, ITheme>`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: ${(props) => props.theme.grid.gutter.horizontal.default};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: flex;
		flex-direction: column;
	}
`;

const StyledInfoCard = styled(InfoCard)`
	padding: ${Css.pxToRem(14)} ${Css.pxToRem(16)};
`;

const StyledShimmerTitleIcon = styled(ShimmerPlaceholderText)`
	width: 32px;
	height: 24px;
`;

const StyledShimmerTitle = styled(ShimmerPlaceholderText)`
	width: 140px;
	height: 24px;
`;

const StyledShimmerDescription = styled(ShimmerPlaceholderText)`
	width: 166px;
	height: 16px;
`;

const StyledShimmerIcons = styled(ShimmerPlaceholderText)`
	width: 52px;
	height: 24px;
`;

const StyledShimmerRemark = styled(ShimmerPlaceholderText)`
	width: 50px;
	height: 16px;
`;

const TopSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Css.pxToRem(4)};
`;

const StyledShimmerBottomLeft = styled(ShimmerPlaceholderText)`
	width: 90px;
	height: 24px;
`;
